import emkt from '../../emkt'
import $ from 'jquery'

export default {
  computed: {
    payType () {
      // 个人发票支付
      if (this.selectedBalanceType === emkt.BALANCE_TYPE_CUSTOMER && this.selectedPayType === emkt.PAY_TYPE_FAPIAO) {
        return '3'
      }
      // 个人余额支付
      if (this.selectedBalanceType === emkt.BALANCE_TYPE_CUSTOMER && this.selectedPayType === emkt.PAY_TYPE_REMAIN_MONEY) {
        return '1'
      }
      // 课题组结算（发票报账）
      if (this.selectedBalanceType !== emkt.BALANCE_TYPE_CUSTOMER && this.selectedPayType === emkt.PAY_TYPE_FAPIAO) {
        return this.selectedBalanceType.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP ? '6' : '3'
      }
      // 课题组结算（余额支付）
      if (this.selectedBalanceType !== emkt.BALANCE_TYPE_CUSTOMER && this.selectedPayType === emkt.PAY_TYPE_REMAIN_MONEY) {
        return this.selectedBalanceType.settlementAccountType === emkt.SETTLEMENT_ACCOUNT_TYPE_RESEARCH_GROUP ? '7' : '1'
      }
    }
  },
  methods: {
    openPayMethodBox () {
      this.showChoosePayMethod = true
      if (this.selectedPayType === emkt.PAY_TYPE_REMAIN_MONEY && !this.verifyFinish) {
        this.showAccountVerifyBox = true
      }
      if (!this.verifyFinish) {
        this.nameQuery = ''
        this.mobileQuery = ''
        this.verifyCode = ''
      }
    },
    handlePayTypeChange () {
      if (this.selectedPayType === emkt.PAY_TYPE_REMAIN_MONEY) {
        this.payByRestMoney()
      } else {
        this.showAccountVerifyBox = false
      }
      this.checkSettmentAccount()
    },
    updatePayMethod () {
      if (this.selectedPayType === emkt.PAY_TYPE_REMAIN_MONEY && !this.verifyFinish) {
        this.linkRestMoneyAccount()
      } else {
        this.closeChoosePayMethodBox()
        this.choosevip(this.payTypeOptionMapping[this.payType])
      }
    },
    closeChoosePayMethodBox () {
      this.showChoosePayMethod = false
    },
    sendVeriCode () {
      this.gcapi('gcwwwifc/applyPrepayCustomer', {
        'Mobile': this.mobileQuery
      })
      let wait = 60
      function time (o) {
        if (wait === 0) {
          o.innerHTML = '验证'
          o.style.color = '#5878fa'
          wait = 60
        } else {
          o.innerHTML = wait + 's'
          o.style.color = '#C8C8C8'
          wait--
          setTimeout(function () {
            time(o)
          }, 1000)
        }
      }
      time($('#enterBtn')[0])
    },
    linkRestMoneyAccount () {
      if (this.verifyFinish) {
        this.choosevip(this.payTypeOptionMapping[this.payType])
        this.closeChoosePayMethodBox()
        return
      }
      this.gcapi('gcwwwifc/confirmPrepayCustomer', {
        'Mobile': this.mobileQuery,
        'VerifyCode': this.verifyCode
      }).then((response) => {
        if (response.body.code !== 0) {
          this.$weui.topTips('请先验证余额账户', 2000)
          // $.toast('请先验证余额账户')
          return
        }
        let customerNo = response.body.result
        this.restPayCustomerNo = customerNo
        this.verifyFinish = true
        this.$weui.toast('绑定成功', 1500)
        this.getSettlementAccount()
        this.choosevip(this.payTypeOptionMapping[this.payType])
        this.closeChoosePayMethodBox()
      })
    },
    getSettlementAccount () {
      let customerNo = this.sessionInfo.customerInfo.customerNo
      this.gcapi('getSettlementAccountListInfo', customerNo).then(res => {
        if (res.body.result) {
          this.settlementAccountList = res.body.result
          if (!this.settlementAccountList || this.settlementAccountList.length === 0) {
            this.$weui.toast('请选择结算账户或者联系业务员给您新建结算账户', 1500)
            return
          }
          // 获取所有课题组列表,选择课题组初始默认值
          this.SettlementAccountNameList = this.settlementAccountList.map((group) => {
            return group.settlementAccountName
          })
        }
      })
    },
    checkRestMoneyAccount () {
      this.verifyCode = ''
      this.verifyFinish = false
      let myreg = /^(1[3456789]\d{9})$/
      if (!myreg.test(this.mobileQuery)) {
        this.$weui.topTips('请输入正确的手机号', 2000)
        return
        // return $.toast('请输入正确的手机号')
      }
      this.$weui.loading('验证中')
      // $.showPreloader('验证中')
      this.gcapi('gcwwwifc/verifyPrepayCustomer', {
        'CustomerName': this.nameQuery,
        'Mobile': this.mobileQuery
      }).then((response) => {
        this.$weui.loading().hide()
        let customerNo = response.body.result
        if (customerNo) {
          this.verifyFinish = true
          this.restPayCustomerNo = customerNo
          this.verifyCode = '验证通过(再次使用无需验证码)'
          $('#search_code')[0].style.color = '#60D837'
        } else {
          this.sendVeriCode()
        }
      })
    },
    payByRestMoney () {
      console.log('payByRestMoney')
      this.yueyanzheng = false
      if(this.order.specialFundCouponUsed === 1) {
        console.log(this.chosenSettlementAccount)
        this.verifyFinish = true
        this.showAccountVerifyBox = false
        if(!this.chosenSettlementAccount.prepayCustomerNo) {
          this.$weui.toast('请使用优惠券拥有者的课题组结算账户', 1500)
        } else {
          this.restPayCustomerNo = this.chosenSettlementAccount.prepayCustomerNo
        }
        return
      }
      if (this.sessionInfo.customerInfo.prepayMoneyRemain === undefined || this.sessionInfo.customerInfo.prepayMoneyRemain === 0) {
        this.showAccountVerifyBox = true
      } else {
        this.verifyFinish = true
        this.showAccountVerifyBox = false
        this.restPayCustomerNo = this.sessionInfo.customerInfo.customerNo
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views_v_2.6/PrivateMixins/OrderConfirmationMixin.js